import React, { useState } from "react";
import NCALayerService from "../../services/NCALayerService/NCALayerService";
import SDKUserFormService from "../../services/SDKUserFormService";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ErrorModal from "../../component/ErrorModal";
// import SuccessModal from "../../component/SuccessModal";


const SDKUserForm = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { validatedBIN } = location.state || null;
  const { validatedOrganizationName } = location.state || null;
  const { validatedIIN } = location.state;
  const [bin, setBin] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [informationSystemName, setInformationSystemName] = useState("");
  const [iin, setIin] = useState("");
  const [personalPhoneNumber, setPersonalPhoneNumber] = useState("+7");
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [isInputFocusedPhoneNumber, setIsInputFocusedPhoneNumber] = useState(false);
  const [email, setEmail] = useState("");
  const [userCount, setUserCount] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isInputFocusedEmail, setIsInputFocusedEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  // const [successMessage, setSuccessMessage] = useState(null);

  const xmlString = `<?xml version="1.0" encoding="UTF-8"?>
  <root>
    <bin>${validatedBIN || bin}</bin>
    <organizationName>${escapeXml(
      validatedOrganizationName || organizationName
    )}</organizationName>
    <informationSystemName>${escapeXml(
      informationSystemName
    )}</informationSystemName>
    <iin>${validatedIIN || iin}</iin>
    <personalPhoneNumber>${escapeXml(personalPhoneNumber)}</personalPhoneNumber>
    <email>${escapeXml(email)}</email>
    <userCount>${escapeXml(userCount)}</userCount>
    </root>`;

  const navigate = useNavigate();
  function escapeXml(unsafe) {
    return unsafe.replace(/[&<>"']/g, function (match) {
      switch (match) {
        case "&":
          return "&amp;";
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case '"':
          return "&quot;";
        case "'":
          return "&apos;";
        default:
          return match;
      }
    });
  }

  const handleSign = async (e) => {
    e.preventDefault();
    if (
      informationSystemName.trim() === "" ||
      !isValidPhoneNumber ||
      personalPhoneNumber === "+7" ||
      !isValidEmail ||
      email === "" ||
      userCount.trim() === "" ||
      userCount.trim() === "0"
    ) {
      setErrorMessage("error.correctInputError");
      // setSuccessMessage('');
      return;
      
    }

    try {
      const xmlResult = await NCALayerService.sign(
        xmlString,
        "1.3.6.1.5.5.7.3.4"
      );
      console.log(xmlResult);
      if (xmlResult == undefined) {
        navigate("/error", {
          replace: true,
          state: { error: t("error.ncalayer") },
        });
      } else {
        await SDKUserFormService.save(xmlResult);
        // setSuccessMessage("getSDKForm.success");
        navigate("/success", { replace: true });
      }

      // navigate("/check-form/user-form/success");
    } catch (error) {
      console.error("Произошла ошибка:", error);
      if (
        error.response &&
        error.response.status === 404 &&
        error.response.data.includes("foreign.key")
      ) {
        setErrorMessage("error.foreignKeyErrorForm");
        console.error("Используется чужая подпись");
      } else if (error.response && error.response.status === 404) {
        setErrorMessage("error.foreignKeyErrorForm");
        console.error("Ошибка: 404 invalidSignatureError");
      } else if (error.response && error.response.status === 500){
        setErrorMessage("error.revokedKeyError");
      }else {
        // Обработка других случаев ошибок
        console.error("Другая ошибка:", error.message);
        navigate("/error", { replace: true });
      }
    }
  };

  ///////////////////////////////
  

  

  //////////////email////////////////////
  const validateEmail = (inputEmail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(inputEmail);
    setIsValidEmail(isValid);
    return isValid;
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (isInputFocusedEmail) {
      validateEmail(newEmail);
    }
  };
  const handleInputFocus = () => {
    setIsInputFocusedEmail(true);
  };

  const handleInputBlur = () => {
    setIsInputFocusedEmail(false);
    validateEmail(email);
  };
  // //////////////////////////////////////////////////////////
  const validatePhoneNumber = (inputNumber) => {
    const phoneNumberRegex = /^(\+7|8)?\d{10}$/;
    const isValid = phoneNumberRegex.test(inputNumber);
    setIsValidPhoneNumber(isValid);
    return isValid;
  };

  const handlePersonalPhoneChange = (e) => {
    const inputValue = e.target.value;
    setPersonalPhoneNumber(inputValue);
    if (isInputFocusedPhoneNumber) {
      validatePhoneNumber(inputValue);
    }
  };

  const handleInputFocusPhoneNumber = () => {
    setIsInputFocusedPhoneNumber(true);
  };

  const handleInputBlurPhoneNumber = () => {
    setIsInputFocusedPhoneNumber(false);
    validatePhoneNumber(personalPhoneNumber);
  };

  ///////////////////////////////////////////////////

  const handleUserCountChange = (e) => {
    let inputValue = e.target.value;

    let onlyNumbers = inputValue.replace(/[^\d]/g, "");

    onlyNumbers = onlyNumbers.replace(/^0+/, "");

    if (onlyNumbers === "") {
      setUserCount("");
    } else {
      setUserCount(onlyNumbers);
    }
  };

  return (
    <div className="content">
      <div className="titleCell">
        <span>{t("SDKUserForm.titleRegistration")}</span>
      </div>

      <form id="indexForm" className="indexForm">
        <div className="vktHeaderDiv">{t("SDKUserForm.formTitle")}</div>
        {errorMessage && <ErrorModal errorMessage={t(errorMessage)} />}
        {/* {successMessage && (
              <div style={{marginBottom: '15px'}}>
                  <SuccessModal successMessage={successMessage} />
              </div>
            )} */}

        <table style={{ width: "100%" }}>
          <tbody>
            {validatedBIN && (<tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.bin")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="12"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder={t("SDKUserForm.mandatoryPlaceholder")}
                            value={validatedBIN || bin}
                            onChange={(e) => setBin(e.target.value)}
                            disabled={!!validatedBIN} // Заблокируйте поле, если validatedIIN существует
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>)}
         {validatedOrganizationName && (  <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.organizationName")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="255"
                            className="ui-no-auto ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder={t("SDKUserForm.mandatoryPlaceholder")}
                            value={
                              validatedOrganizationName || organizationName
                            }
                            onChange={(e) =>
                              setOrganizationName(
                                e.target.value || validatedOrganizationName
                              )
                            }
                            disabled={!!validatedOrganizationName}
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr> )}
         
            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.iin")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="12"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder={t("SDKUserForm.mandatoryPlaceholder")}
                            value={validatedIIN || iin}
                            onChange={(e) =>
                              setIin(e.target.value || validatedIIN)
                            }
                            disabled={!!validatedIIN}
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.informationSystem")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="255"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin no-disable-field"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder={t("SDKUserForm.mandatoryPlaceholder")}
                            value={informationSystemName}
                            onChange={(e) =>
                              setInformationSystemName(e.target.value)
                            }
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.phoneNumber")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="12"
                            pattern="\d*"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin no-disable-field"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder="+7(_ _ _) _ _ _ - _ _ - _ _"
                            value={personalPhoneNumber}
                            onChange={handlePersonalPhoneChange}
                            onFocus={handleInputFocusPhoneNumber}
                            onBlur={handleInputBlurPhoneNumber}
                          />
                        </span>
                        {!isValidPhoneNumber &&
                          !isInputFocusedPhoneNumber &&
                          (personalPhoneNumber.trim() !== "" ||
                            personalPhoneNumber === "+7") && (
                            <div className="error-message">
                              {t("SDKUserForm.errorPhoneNumber")}
                            </div>
                          )}
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:5:labels">
                          {t("SDKUserForm.email")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:5:values">
                          <input
                            id="rcfield:5:inputValue"
                            name="rcfield:5:inputValue"
                            type="text"
                            maxLength="255"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 email no-disable-field"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder="example@example.kz"
                            value={email}
                            onChange={handleEmailChange}
                            onFocus={handleInputFocus}
                            onBlur={handleInputBlur}
                          />
                        </span>
                        {!isValidEmail &&
                          !isInputFocusedEmail &&
                          email.trim() !== "" && (
                            <div className="error-message">
                              {t("SDKUserForm.errorEmail")}
                            </div>
                          )}
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:0:labels">
                          {t("SDKUserForm.userCount")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:0:values">
                          <input
                            id="rcfield:0:inputValue"
                            name="rcfield:0:inputValue"
                            type="text"
                            maxLength="12"
                            className="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin no-disable-field"
                            role="textbox"
                            aria-disabled="false"
                            aria-readonly="false"
                            placeholder="139549"
                            value={userCount}
                            onChange={handleUserCountChange}
                          />
                        </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:5:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <div
          style={{
            backgroundColor: "#DEE5EB",
            padding: "5px",
            borderRadius: "1px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            margin: "5px 0",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              fontFamily: "Montserrat, sans-serif",
              color: "#333",
              margin: 0,
            }}
          >
            {t("SDKUserForm.noteRegistration")}
          </p>
        </div> */}
        <span id="ncalayerCallBlock" className="tooltip-container">
  <button
    id="submitDataBTest"
    name="submitDataBTest"
    className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only new-blue-btn w-100"
    onClick={handleSign}
    type="submit"
    role="button"
    aria-disabled="false"
  >
    <span className="tooltip_element">
      {t("SDKUserForm.signButton")}
    </span>
  </button>
  
  <div className="tooltip-text">
  <p>{t("SDKUserForm.moduleHint")}</p>
  <p>{t("SDKUserForm.moduleHintNext")}</p>
  </div>
</span>
      </form>
    </div>
  );
};

export default SDKUserForm;
